export default {
  noSelection: '--No Seleccionar--',
  weighing: 'PONDERACIÓN',
  type: 'TIPO',
  mergeConfirmTitle: '¿Combinar los datos de la Actividad/Evaluación con la sesión?',
  mergeConfirmText:
    'Se agregarán a la sesión: {achievementIndicators}, contenidos, {methodologicalStrategies}, {autonomousActivities} y bibliografía de la Actividad/Evaluación seleccionada, sin quitar lo que ya esté seleccionado. Si cancela, solo se guardará el vínculo con la Actividad/Evaluación.',
  selectionsMerged:
    'Se agregaron a la sesión los datos de la Actividad/Evaluación seleccionada.',
};
